export default "__VITE_ASSET___6dfIzgc__"